import { render } from "./alerts.vue?vue&type=template&id=65c5ea2e&scoped=true&ts=true"
import script from "./alerts.vue?vue&type=script&lang=ts"
export * from "./alerts.vue?vue&type=script&lang=ts"

import "./alerts.vue?vue&type=style&index=0&id=65c5ea2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c5ea2e"]])

export default __exports__